exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1[data-v-0dcc29e7], h2[data-v-0dcc29e7] {\n  font-weight: normal;\n}\nul[data-v-0dcc29e7] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-0dcc29e7] {\n  display: inline-block;\n  margin: 0 10px;\n}\n.fade-enter-active[data-v-0dcc29e7], .fade-leave-active[data-v-0dcc29e7] {\n  transition: opacity .5s\n}\n.fade-enter[data-v-0dcc29e7], .fade-leave-to[data-v-0dcc29e7] /* .fade-leave-active in <2.1.8 */ {\n  opacity: 0\n}\n.nav-tabs > li[data-v-0dcc29e7], .nav-pills > li[data-v-0dcc29e7] {\n  float:none;\n  display:inline-block;\n  *display:inline; /* ie7 fix */\n   zoom:1; /* hasLayout ie7 trigger */\n}\n.nav-tabs[data-v-0dcc29e7] {\n  text-align:center;\n}\nimg[data-v-0dcc29e7] {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0dcc29e7","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/home/Home.vue
// module id = 891
// module chunks = 1